import React, { useState } from 'react';
import { textblocks, buttons, forms } from 'seal-ui-components';
import store from '@Store';
import { AUTHENTICATION } from '@Constants/types';
import Divider from '@Components/UI/Divider';
import NewDialogPopUp from '@Components/UI/NewDialogPopUp/NewDialogPopUp';
import { setInStorage, STORAGE_TYPE } from '@Service/storageService';
import environment from '../../../../environment/version';
import {
    Header,
    LinkWrapper,
    InnerFrameWrapper,
    Footer,
    ReleaseNotesDialogWrapper
} from './ReleaseNotesDialog.style';

const ReleaseNotesDialog = ({ isVisible, dialogAnimationStartDimension }) => {
    const [showAgain, setShowAgain] = useState(false);

    const { version, notes } = environment;
    var { userGuideUrl } = environment;

    if (userGuideUrl === '{USER_GUIDE_URL}') {
        userGuideUrl = 'https://support.docusign.com'; // default to support center
    }

    const handleCheckbox = () => {
        setShowAgain(!showAgain);
    };

    const handleCloseButton = () => {
        if (showAgain) {
            setInStorage('lastVersion', version, STORAGE_TYPE.LOCAL_STORAGE);
        }
        store.dispatch({ type: AUTHENTICATION.TOGGLE_RELEASE_DIALOG });
    };

    return (
        <NewDialogPopUp
            isVisible={isVisible}
            dialogAnimationStartDimension={dialogAnimationStartDimension}
        >
            <ReleaseNotesDialogWrapper>
                <Header>
                    <textblocks.Heading1>{"What's new"}</textblocks.Heading1>
                    <textblocks.Heading4>Version {version}</textblocks.Heading4>
                </Header>
                <Divider />
                <InnerFrameWrapper>
                    <ul>
                        {notes &&
                            notes.length > 0 &&
                            notes.map((note, idx) => <li key={idx}>{note}</li>)}
                    </ul>
                </InnerFrameWrapper>
                <Divider />
                <LinkWrapper>
                    <a href={userGuideUrl} target="_blank" rel="noopener noreferrer">
                        Open user guide
                    </a>
                </LinkWrapper>
                <Footer>
                    <forms.CheckboxField
                        checked={showAgain}
                        label="Don't show again"
                        onChange={handleCheckbox}
                    />
                    <buttons.Button
                        appearance="secondary"
                        size="medium"
                        onClick={handleCloseButton}
                    >
                        Close
                    </buttons.Button>
                </Footer>
            </ReleaseNotesDialogWrapper>
        </NewDialogPopUp>
    );
};

export default ReleaseNotesDialog;
